import { createFileRoute } from '@tanstack/react-router'

export const Route = createFileRoute('/auth/(auth)/create-city-clerk')({
  component: CreateCityClerkPage,
})

function CreateCityClerkPage() {
  return <div>Create City Clerk Page</div>
}
